import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { Column } from 'react-table'
import { BaseTable, IColumn } from '../../components/BaseTable'
import NoResultsTable from '../../components/NoResultsTable'
import { useConfigTable } from '../../hooks/useConfigTable'
import { tableStore } from '../../stores/TableStore'
import { resourceTabela } from '../../utils/resourcesTabela'
import { AddRecord, Paper, TableContainer } from '../../components'
import Spacer from '../../components/Spacer'
import { cenariosColumns } from './cenariosColumns'
import { useCenarioMetadata } from './hooks/useCenarioMetadata'
import { cenariosStore } from './stores/cenarios'
import { CenarioDetail } from './types'

interface Props {
  onDelete: (id: string) => void
  authorization?: {
    canCreate: boolean
    canDelete: boolean
    canUpdate: boolean
  }
}

export const CenariosTable = observer(({ onDelete, authorization }: Props) => {
  const { pathname } = useLocation()
  const [{ metadata }, actions] = useCenarioMetadata()

  useEffect(() => {
    actions.fetchIfNeeded()
  }, []) // eslint-disable-line

  const KEY_TABLE = resourceTabela.CENARIOS
  useConfigTable(KEY_TABLE)
  const tableState = tableStore.getState(KEY_TABLE)
  const isTableReady =
    !cenariosStore.cenarios.isLoading &&
    tableState &&
    cenariosStore.cenarios.list.length

  const columns: Array<Column & IColumn> = useMemo(
    () => cenariosColumns({ onDelete, authorization, metadata }),
    [onDelete, authorization, metadata]
  )

  const rows = cenariosStore.cenarios.list.map((cenario: CenarioDetail) => ({
    ...cenario
  }))

  return (
    <>
      <Spacer y={4} />
      <Paper>
        <TableContainer
          loading={cenariosStore.cenarios.isLoading}
          totalCount={cenariosStore.cenarios.totalCount}
        >
          {isTableReady ? (
            <BaseTable
              keyTable={KEY_TABLE}
              columns={columns}
              hasConditionClickRow={false}
              linkWithRedirectClickRow={pathname}
              data={rows}
            />
          ) : (
            <NoResultsTable loading={cenariosStore.cenarios.isLoading} />
          )}
        </TableContainer>
      </Paper>

      <AddRecord path={pathname} authorization={authorization} />
    </>
  )
})
